export enum CRMTypeEnum {
  salesforce,
  zendesk,
}
